<template>
    <div class="box">
        <el-container class="example">
            <el-header>
                <Header></Header>
            </el-header>
            <el-main>
                <appMain></appMain>
            </el-main>
            <el-footer>
                <Footer></Footer>
            </el-footer>
        </el-container>
    </div>
</template>

<script setup name="layout">
import Header from '../components/headers/index';
import Footer from '../components/footers/index';
import appMain from './appMain.vue';
</script>

<style lang="scss" scoped>
.box {

    // background: linear-gradient(to right, #f1f5fc 0%, #e3e9f8 100%);
    .el-main {
        padding: 16px 20px 0 20px;
    }

    .el-main::-webkit-scrollbar {
        display: none !important;
        scrollbar-width: none !important;
        /* Firefox */
        -ms-overflow-style: none !important;
        /* IE/Edge */

    }

    .no-scrollbar {
        scrollbar-width: none !important;
        /* Firefox */
        -ms-overflow-style: none !important;
        /* IE/Edge */
    }
}

/* 超小设备 (手机, 600px 以下屏幕设备) */
@media only screen and (max-width: 600px) {
    .example {}
}

/* 小设备 (平板电脑和大型手机，600 像素及以上) */
@media only screen and (min-width: 600px) {
    .example {}
}

/* 中型设备（平板电脑，768 像素及以上） */
@media only screen and (min-width: 768px) {
    .example {}
}

/* 大型设备（笔记本电脑/台式机，992 像素及以上） */
@media only screen and (min-width: 1092px) {
    .example {}
}

/* 大型设备（笔记本电脑/台式机，1092 像素及以上） */
@media only screen and (min-width: 1092px) {
    .example {
        // width: 1092px;
        // margin: auto;
    }
}

/* 超大型设备（大型笔记本电脑和台式机，1200 像素及以上） */
@media only screen and (min-width: 1200px) {
    .example {}
}

// @media screen and (max-width:1200px) {
//     .container {
//         width: 100%;
//         display: flex;
//         flex-direction: column;
//         // justify-content: center;
//         .el-main {
//             width: 100%;
//         }
//     }
// }

// @media screen and (min-width:1200px) {
//     .container {
//         width: 100%;
//         display: flex;
//         flex-direction: column;
//         // justify-content: center;
//         .el-main {
//             width: 1200px;
//         }
//     }
// }</style>